import { Checkbox } from '@mui/material';
import { useState } from 'react';
import { TableInput } from '../../../../../components/common';

interface IProps {
  moduleData: any;
  isView: boolean;
  partData: any;
}

const TBody = ({ moduleData, isView, partData }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <tbody>
      {moduleData.employees.map((employee: any, index: any) => (
        <tr>
          <td>{index + 1}</td>
          <td>{employee.employee_id?.employee_name}</td>
          <td>{employee.employee_id?.employee_code}</td>
          <td>{employee.employee_id?.level}</td>
          {partData.map((part: any) => (
            <td>
              {isView ? (
                employee[part._id] && '✓'
              ) : (
                <Checkbox
                  name="part_number"
                  color="primary"
                  checked={employee.part_ids.includes(part._id)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      employee.part_ids.push(part._id);
                    } else {
                      const index = employee.part_ids.indexOf(part._id);
                      if (index !== -1) employee.part_ids.splice(index, 1);
                    }
                    setRender((prev) => !prev);
                  }}
                />
              )}
            </td>
          ))}
          <td>
            <TableInput
              name="remarks"
              type="text"
              value={employee.remarks}
              onChange={(e) => {
                employee.remarks = e.target.value;
                setRender((prev) => !prev);
              }}
              isView={isView}
            />
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default TBody;
